import styled from 'styled-components';

export const StyledCalendarPanel = styled.div`
   display: flex;
   flex: 1;
   overflow: hidden;
   gap: 34px;
`;

StyledCalendarPanel.displayName = 'StyledCalendarPanel';
